import PropTypes from "prop-types";
import React from "react";
import { convertFromRaw } from "draft-js";
import { outcomePropType } from "../../lib/dataShapes";
import { Qualities, outcomeWithData } from "../../lib/utils";
import { contAbsoluteEffect, contSofControl } from "../../lib/formatters";
import Collapsible from "../common/Collapsible";
import HeaderContentBox from "../common/HeaderContentBox";
import OutcomeEffectBox from "./OutcomeEffectBox";
import OutcomeName from "./OutcomeName";
import styles from "../../styles/outcomeTable.module.scss";

const ContOutcomeTableRow = ({ intervention, outcome }) => {
  const outcomeHasData = outcomeWithData(outcome.metaType);
  const hasComment = convertFromRaw(outcome.comments).hasText();
  return (
    <div className={styles.outcomeTableRow}>
      <Collapsible
        calculateHeight={true}
        expandable={outcomeHasData || hasComment}
      >
        <div className={styles.outcomeRow}>
          <div className={styles.outcomeNameCell}>
            <OutcomeName outcome={outcome} />
          </div>
          <div className={styles.effects}>
            <div className={styles.comparisonEffect}>
              <OutcomeEffectBox
                data={
                  outcomeHasData ? contSofControl(outcome, intervention) : "-"
                }
                type={
                  outcome.calculatedControlFavours === "intervention"
                    ? "violet"
                    : "white"
                }
              />
            </div>
            <div className={styles.interventionEffect}>
              <OutcomeEffectBox
                data={outcomeHasData ? contAbsoluteEffect(outcome) : "-"}
                type={
                  outcome.calculatedControlFavours === "comparison"
                    ? "blue"
                    : "white"
                }
              />
            </div>
          </div>
          <div
            className={styles.outcomeCertainty}
            dangerouslySetInnerHTML={{
              __html:
                outcome.quality && `${Qualities[outcome.quality]}<br>certainty`
            }}
          />
        </div>
        <div className={styles.outcomeContent}>
          {hasComment && (
            <div className={styles.whatHappens}>
              <HeaderContentBox
                title="What happens"
                content={outcome.comments}
              />
            </div>
          )}
        </div>
      </Collapsible>
    </div>
  );
};

ContOutcomeTableRow.propTypes = {
  comparison: PropTypes.string.isRequired,
  intervention: PropTypes.string.isRequired,
  outcome: PropTypes.shape(outcomePropType).isRequired
};

export default ContOutcomeTableRow;
